import React, { useState } from 'react';
import {
  Button,
  Form,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import {
  FaFacebook, FaLinkedin, FaPhoneAlt, FaMobile,
} from 'react-icons/fa';
import { BsFillEnvelopeFill, BsGeoAlt } from 'react-icons/bs';
import { BiLink } from 'react-icons/bi';
import '../style/style.css';
import PropTypes from 'prop-types';
import updateContact from '../services/Contacts';
import SuccessMessage from './SuccessMessage';

/* eslint no-underscore-dangle: 0 */

export default function ContactsEdit({ Contacts }) {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState(Contacts.email);
  const [mobile, setMobile] = useState(Contacts.mobile);
  const [telephone, setTelephone] = useState(Contacts.telephone);
  const [address, setAddress] = useState(Contacts.address);
  const [postalcode, setPostalCode] = useState(Contacts.postalcode);
  const [facebook, setFacebook] = useState(Contacts.facebook);
  const [linkedin, setLinkedin] = useState(Contacts.linkedin);
  const [linkMaps, setLinkMaps] = useState(Contacts.linkMaps);

  let succeed = false;

  const editContacts = async (e) => {
    e.preventDefault();
    const formEmail = document.getElementById('edit-new-email');
    const formMobile = document.getElementById('edit-new-mobile');
    const formTelephone = document.getElementById('edit-new-telephone');
    const formAddress = document.getElementById('edit-new-address');
    const formPostalcode = document.getElementById('edit-new-postal-code');
    const formFacebook = document.getElementById('edit-new-facebook');
    const formLinkedin = document.getElementById('edit-new-linkedin');
    const formLinkMaps = document.getElementById('edit-new-link-maps');

    succeed = true;

    if (
      formEmail.value !== email
      || formMobile.value !== mobile
      || formTelephone.value !== telephone
      || formPostalcode.value !== postalcode
      || formFacebook.value !== facebook
      || formLinkedin.value !== linkedin
      || formAddress.value !== address
      || formLinkMaps.value !== linkMaps
    ) {
      updateContact(
        Contacts._id,
        formEmail.value,
        formMobile.value,
        formTelephone.value,
        formAddress.value,
        formPostalcode.value,
        formFacebook.value,
        formLinkedin.value,
        formLinkMaps.value,
      )
        .catch((err) => {
          succeed = false;
          if (err.response !== undefined) {
            document.getElementById(Contacts._id).textContent = err.response.data.message;
          }
        })
        .then(() => {
          if (succeed) {
            setEmail(formEmail.value);
            setMobile(formMobile.value);
            setTelephone(formTelephone.value);
            setAddress(formAddress.value);
            setPostalCode(formPostalcode.value);
            setFacebook(formFacebook.value);
            setLinkedin(formLinkedin.value);
            setLinkMaps(formLinkMaps.value);

            document.getElementById(Contacts._id).textContent = '';
            setShow(false);
            setShow(true);
          }
        });
    }
  };

  const reset = async (e) => {
    e.preventDefault();
    document.getElementById('edit-new-email').value = email;
    document.getElementById('edit-new-mobile').value = mobile;
    document.getElementById('edit-new-telephone').value = telephone;
    document.getElementById('edit-new-address').value = address;
    document.getElementById('edit-new-postal-code').value = postalcode;
    document.getElementById('edit-new-facebook').value = facebook;
    document.getElementById('edit-new-linkedin').value = linkedin;
    document.getElementById('edit-new-link-maps').value = linkMaps;
    document.getElementById(Contacts._id).textContent = null;
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Para obter o link, &eacute; preciso seguir os passos 1 ao 5 da
      sec&ccedil;&atilde;o &apos;Incorporar um mapa ou
      dire&ccedil;&otilde;es&apos; desta
      <a href="https://support.google.com/maps/answer/144361?hl=pt&co=GENIE.Platform%3DDesktop" target="_blank" rel="noreferrer">
        {' '}
        página
      </a>
      . Da linha obtida no link, retira-se o conte&uacute;do que est&aacute; em
      src=&quot;...&quot;.
    </Tooltip>
  );

  return (
    <div className="contacts-edit" id="editar-contactos">
      <Form id="contacts-edit">
        <Form.Group className="mb-3">
          <Form.Label className="title mb-1">Editar Contactos</Form.Label>
          <hr className="edit-divider" />
          <div id="contacts-edit-card">
            <Row>
              <Col sm={6} xs={12}>
                <Row className="d-flex align-items-center">
                  <Form.Label column lg={1} md={2} className="card-label me-2">
                    <FaMobile className="footer-icon footer-icon-edit" />
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control
                      as="textarea"
                      id="edit-new-mobile"
                      rows={1}
                      style={{ resize: 'none' }}
                      defaultValue={Contacts.mobile}
                      placeholder="Adicione número de telemóvel"
                    />
                  </Col>
                </Row>
              </Col>
              <Col sm={6} xs={12}>
                <Row className="d-flex align-items-center">
                  <Form.Label column lg={1} md={2} className="card-label me-2">
                    <FaPhoneAlt className="footer-icon footer-icon-edit" />
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control
                      as="textarea"
                      id="edit-new-telephone"
                      rows={1}
                      style={{ resize: 'none' }}
                      defaultValue={Contacts.telephone}
                      placeholder="Adicione número de telefone"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col sm={6} xs={12}>
                <Row className="d-flex align-items-center">
                  <Form.Label column lg={1} md={2} className="card-label me-2">
                    <FaFacebook className="footer-icon footer-icon-edit" />
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control
                      as="textarea"
                      id="edit-new-facebook"
                      rows={1}
                      style={{ resize: 'none' }}
                      defaultValue={Contacts.facebook}
                      placeholder="Adicione facebook"
                    />
                  </Col>
                </Row>
              </Col>
              <Col sm={6} xs={12}>
                <Row className="d-flex align-items-center">
                  <Form.Label column lg={1} md={2} className="card-label me-2">
                    <FaLinkedin className="footer-icon footer-icon-edit" />
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control
                      as="textarea"
                      id="edit-new-linkedin"
                      rows={1}
                      style={{ resize: 'none' }}
                      defaultValue={Contacts.linkedin}
                      placeholder="Adicione linkedin"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col sm={6} xs={12}>
                <Row className="d-flex align-items-center">
                  <Form.Label column lg={1} md={2} className="card-label me-2">
                    <BsFillEnvelopeFill className="footer-icon footer-icon-edit" />
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control
                      as="textarea"
                      id="edit-new-email"
                      rows={1}
                      style={{ resize: 'none' }}
                      defaultValue={Contacts.email}
                      placeholder="Adicione email"
                    />
                  </Col>
                </Row>
              </Col>
              <Col sm={6} xs={12}>
                <Row className="d-flex align-items-center">
                  <Form.Label column lg={1} md={2} className="card-label me-2">
                    <BsGeoAlt className="footer-icon footer-icon-edit" />
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control
                      as="textarea"
                      id="edit-new-postal-code"
                      rows={1}
                      style={{ resize: 'none' }}
                      defaultValue={Contacts.postalcode}
                      placeholder="Adicione código de postal"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col sm={6} xs={12}>
                <Row className="d-flex align-items-center">
                  <Form.Label column lg={1} md={2} className="card-label me-2">
                    <BsGeoAlt className="footer-icon footer-icon-edit" />
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control
                      as="textarea"
                      id="edit-new-address"
                      rows={3}
                      style={{ resize: 'none' }}
                      defaultValue={Contacts.address}
                      placeholder="Adicione morada"
                    />
                  </Col>
                </Row>
              </Col>
              <Col sm={6} xs={12}>
                <Row className="d-flex align-items-center">
                  <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 500, hide: 700 }}
                    overlay={renderTooltip}
                  >
                    <Form.Label
                      column
                      lg={1}
                      md={2}
                      className="card-label me-2"
                    >
                      <BiLink className="footer-icon" />
                    </Form.Label>
                  </OverlayTrigger>
                  <Col sm={10}>
                    <Form.Control
                      as="textarea"
                      id="edit-new-link-maps"
                      rows={3}
                      style={{ resize: 'none' }}
                      defaultValue={Contacts.linkMaps}
                      placeholder="Adicione link do google maps"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <div>
              <small id={Contacts._id} className="text-danger pre-wrap">
                {' '}
              </small>
            </div>
            <div className="d-flex justify-content-md-start justify-content-center">
              <Button
                onClick={(e) => editContacts(e)}
                variant="principal btn-custom"
              >
                Guardar alterações
              </Button>
              <Button onClick={(e) => reset(e)} variant="cancel btn-custom">
                Cancelar
              </Button>
            </div>
          </div>
        </Form.Group>
      </Form>
      <SuccessMessage
        show={show}
        setShow={setShow}
        message="Os contactos foram editados com sucesso!"
      />
    </div>
  );
}

ContactsEdit.propTypes = {
  Contacts: PropTypes.instanceOf(Object).isRequired,
};
